/**
 * api接口的统一出口
 */
import BASE from "./base"; // 导入接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
const user = {
    // 登录
    getLogin(params) {
        return axios.post(`${BASE.ZCT_API}/authenication/autoLogin`, params);
    },
    // 身份证验证
    getCardValid(params) {
        return axios.post(`${BASE.ZCT_API}/commonValid/validIdentity`, params);
    },
    // 获取个人信息
    getUserInfo(params) {
        return axios.post(`${BASE.ZCT_API}/zctUser/getPersonInfos`, params);
    },
    // 个人信息认证
    getPersonVaild(params) {
        return axios.post(`${BASE.ZCT_API}/zctUser/personValid`, params)
    },
    // 地区省
    getProvince(params) {
        return axios.post(`${BASE.ZCT_API}/bsProvince/selectAllProvince`, params)
    },
    // 地区市
    getCity(params) {
        return axios.post(`${BASE.ZCT_API}/bsCity/getCity`, params)
    },
    // 地区区
    getArea(params) {
        return axios.post(`${BASE.ZCT_API}/bsArea/getArea`, params)
    },
    // 地区乡镇
    getStreet(params) {
        return axios.post(`${BASE.ZCT_API}/bsStreet/getStreet`, params)
    },
    // 地区省-有村组
    getProvinceVillage(params) {
        return axios.post(`${BASE.ZCT_API}/villageManage/queryProvince`, params)
    },
    // 地区市-有村组
    getCityVillage(params) {
        return axios.post(`${BASE.ZCT_API}/villageManage/queryCity`, params)
    },
    // 地区区-有村组
    getAreaVillage(params) {
        return axios.post(`${BASE.ZCT_API}/villageManage/queryCounty`, params)
    },
    // 地区乡镇-有村组
    getStreetVillage(params) {
        return axios.post(`${BASE.ZCT_API}/villageManage/queryTownship`, params)
    },
    // 地区村组
    getVillage(params) {
        return axios.post(`${BASE.ZCT_API}/villageManage/list`, params)
    },
    // 信息采集选择器
    getInfoSelect(params) {
        return axios.get(`${BASE.ZCT_API}/message/template/menu/col/item/get/${params}`, {})
    },
    // 第一次人脸
    getFaceFirst(params) {
        return axios.post(`${BASE.ZCT_API}/faceVerify/zctuser/first`, params)
    },
    // 获取二维码信息
    getQRCodeInfo(params) {
        return axios.post(`${BASE.ZCT_API}/faceVerify/imageValid`, params);
    },
    // 判断二维码状态-检查人脸识别是否通过
    checkQRCode(params) {
        return axios.post(`${BASE.ZCT_API}/faceVerify/checkIsOk`, params);
    },
    // 判断二维码状态-后续人脸识别
    checkQRCodeValid(params) {
        return axios.post(`${BASE.ZCT_API}/faceVerify/zctuser/valid`, params);
    },
    getUserMsg(params) {
        //http://139.159.144.119/jst/sys/login
        return axios.post(`/MSG/sys/login`, params);
    },
    // 获取信息采集详情
    getFarmersInfo(params) {
        return axios.post(`${BASE.ZCT_API}/farmersInfo/getFarmersInfoByPhone`, params)
    },
    // 信息采集保存
    saveFarmersInfo(params) {
        return axios.post(`${BASE.ZCT_API}/farmersInfo/saveColumnInfo`, params)
    },
    // 信息采集提交
    submitFarmersInfo(params) {
        return axios.post(`${BASE.ZCT_API}/farmerApproval/submit`, params)
    },
    // 我的银行卡列表
    getMyCard(params) {
        // return axios.post(`${BASE.ZCT_API}/bankCard/listMyCard`, params)
        return axios.post(`${BASE.ZCT_API}/personBankCard/listMyCard`, params)
    },
    // 账户管理修改
    getPersonValidResult(params) {
        return axios.post(`${BASE.ZCT_API}/zctUser/personValidResult`, params)
    },
    //承包方式 传listing_mode=contract _mode
    getByCategoryName(params) {
        return axios.post(`${BASE.ZCT_API}/dictionary/getByCategoryName`, params)
    },
    //获取这个区域对应的ProvinceCode等，来做的限制,---传参是areaConfigId
    getAreaCodeById(params) {
        return axios.post(`${BASE.ZCT_API}/areaConfig/getAreaCodeById`, params)
    },
    //获取自定义挂牌方式 -陈老师
    getListByProperties(params) {
        return axios.post(`${BASE.ZCT_API}/businessTypeConfig/getListByProperties`, params)
    },
    //获取自定义挂牌方式 -陈老师
    getFieldsByTypeId(params) {
        return axios.post(`${BASE.ZCT_API}/businessTypeConfig/getFieldsByTypeId`, params)
    },
    // 捷算app人脸二维码
    jsQRCodeInfo(params) {
        return axios.post(`${BASE.ZCT_API}/common/verify/QRCodeInfo`, params)
    },
    // 捷算app人脸轮询
    checkJSQRCode(params) {
        return axios.post(`${BASE.ZCT_API}/common/verify/checkIsOk`, params)
    },
    //行业分类
    getSelectIndustryList(){
        return axios.post(`${BASE.ZCT_API}/industry/selectIndustryList`, {})
    }
};

export default user;
